var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-container section-home" },
    [
      _c(
        "section",
        { staticClass: "section border-bottom-section download-app-container" },
        [
          _vm.loadingPromoCode
            ? _c("div", { staticClass: "section-content" }, [
                _c(
                  "div",
                  { staticClass: "hourglass-outer" },
                  [_c("hourglass")],
                  1
                ),
              ])
            : _c("div", { staticClass: "section-content" }, [
                _c("div", { staticClass: "columns is-valigned-end" }, [
                  _c(
                    "div",
                    { staticClass: "column is-narrow column-app-phone2" },
                    [
                      _c("img", {
                        staticClass: "block",
                        attrs: {
                          src: "/img/phone-it.png",
                          alt: _vm.$t("alt.app"),
                          draggable: "false",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "column column-app-phone1" }, [
                    _c("p", { staticClass: "subtitle no-line-break-mobile" }, [
                      _vm._v(_vm._s(_vm.$t("home.subtitle_l1"))),
                    ]),
                    _c("div", { staticClass: "alert-box" }, [
                      !_vm.submittedCode
                        ? _c(
                            "div",
                            {
                              staticClass: "split-container",
                              staticStyle: { "max-width": "none" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns is-centered is-vcentered is-multiline margin-top-xs",
                                },
                                [
                                  _c("div", { staticClass: "column" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "subtitle no-line-break-mobile",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.promo_code_help1a")
                                          )
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "profile.promo_code_help1b"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.submittedCode
                        ? _c("div", { staticClass: "split-container" }, [
                            _c("div", { staticClass: "form-container" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns is-centered is-vcentered is-multiline",
                                },
                                [
                                  _c("div", { staticClass: "column" }, [
                                    _c(
                                      "div",
                                      { staticClass: "field has-addons" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "control has-icons-left is-expanded",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.promo_code,
                                                  expression: "promo_code",
                                                },
                                              ],
                                              ref: "inputCode",
                                              staticClass: "input",
                                              attrs: {
                                                type: "text",
                                                placeholder: _vm.$t(
                                                  "placeholder.promo_code"
                                                ),
                                                maxlength: "16",
                                              },
                                              domProps: {
                                                value: _vm.promo_code,
                                              },
                                              on: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.submitPromoCode.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.promo_code =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon is-small is-left",
                                              },
                                              [
                                                _c("gift-icon", {
                                                  attrs: { size: "1.5x" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "column is-narrow" },
                                    [
                                      _c("div", { staticClass: "field" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "control has-text-centered",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button is-primary",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: _vm.submitPromoCode,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("button.submit")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.missingCode
                                ? _c(
                                    "article",
                                    {
                                      staticClass: "message is-danger",
                                      attrs: { transition: "fade" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "message-body" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("alert.missing_promo_code")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.invalidCode
                                ? _c(
                                    "article",
                                    {
                                      staticClass: "message is-danger",
                                      attrs: { transition: "fade" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "message-body" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("alert.invalid_promo_code")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.expiredCode
                                ? _c(
                                    "article",
                                    {
                                      staticClass: "message is-danger",
                                      attrs: { transition: "fade" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "message-body" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("alert.expired_promo_code")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.errorPage
                                ? _c(
                                    "article",
                                    {
                                      staticClass: "message is-danger",
                                      attrs: { transition: "fade" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "message-body" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("alert.generic_error")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
        ]
      ),
      _c("section-video", { attrs: { num: 2 } }),
      _c("section-features", { attrs: { num: 3 } }),
      _c("section-luciano", { attrs: { num: 4 } }),
      _c(
        "modal-comp",
        {
          ref: "modalvideo",
          staticClass: "modal-video",
          attrs: { title: _vm.$t("menu.video") },
          on: { close: _vm.videoPopupClosed },
        },
        [
          _vm.videoPopup
            ? _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                _c(
                  "video",
                  {
                    ref: "playervideo",
                    attrs: { width: "854", height: "480", controls: "" },
                  },
                  [
                    _c("source", {
                      attrs: {
                        src: "/videos/workout-ita.mp4",
                        type: "video/mp4",
                      },
                    }),
                    _vm._v(_vm._s(_vm.$t("home.no_video_support"))),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }